module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Content")]), _vm._v(" "), _c('ol', [_c('li', [_c('a', {
    attrs: {
      "href": "#/Text/Section0003"
    }
  }, [_vm._v("The Night of the Long Knives")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friends and Enemies")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Pail of Air")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0